import { render } from "./BzDialog.vue?vue&type=template&id=59dc47ea"
import script from "./BzDialog.vue?vue&type=script&lang=js"
export * from "./BzDialog.vue?vue&type=script&lang=js"

import "./BzDialog.vue?vue&type=style&index=0&id=59dc47ea&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__